import {
  Alert,
  Box,
  ContentLayout,
  Flashbar,
  Header,
  SpaceBetween,
  Spinner,
} from '@cloudscape-design/components';
import {
  usePLC,
  usePLCError,
  usePLCReady,
} from 'features/plc/providers/PLCProvider';
import React from 'react';

import LiveDashboard from './components/dashboard';
import ParameterForm from './components/parameterForm';
import RunControls from './components/runControls';
import RunLogViewer from './components/runLog';
import SetupSelector from './components/setupSelector';

function TestStandRouter() {
  const ready = usePLCReady();
  const connectionError = usePLCError();
  const { writeError, setWriteError } = usePLC();

  if (!ready && !connectionError) {
    return (
      <ContentLayout header={<Header variant="h1">Test Stand</Header>}>
        <Box textAlign="center" padding="xxl">
          <Spinner size="large" />
          <Box variant="p" color="text-status-inactive" padding={{ top: 's' }}>
            Connecting to PLC…
          </Box>
        </Box>
      </ContentLayout>
    );
  }

  return (
    <ContentLayout header={<Header variant="h1">Test Stand</Header>}>
      <SpaceBetween size="l">
        {connectionError && (
          <Alert type="warning" header="PLC not connected">
            {connectionError}
            {' '}
            Showing mock values.
          </Alert>
        )}
        {writeError && (
          <Flashbar
            items={[{
              type: 'error',
              content: writeError,
              dismissible: true,
              onDismiss: () => setWriteError(null),
              id: 'write-error',
            }]}
          />
        )}
        <SetupSelector />
        <ParameterForm />
        <RunControls />
        <LiveDashboard />
        <RunLogViewer />
      </SpaceBetween>
    </ContentLayout>
  );
}

export default TestStandRouter;
